<template lang="">
  <el-form
    ref="loginForm"
    :model="loginForm"
    :rules="loginRules"
    class="login-form"
    autocomplete="on"
    label-position="left"
  >
    <el-form-item prop="mobile">
      <el-input
        ref="mobile"
        v-model="loginForm.mobile"
        name="mobile"
        type="text"
        size="large"
        placeholder="请输入手机号"
      >
        <template #prefix>
          <el-icon class="el-input__icon"><Phone /></el-icon>
        </template>
      </el-input>
    </el-form-item>

    <!-- 图片验证码输入框 -->
    <el-form-item prop="captchaCode">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            v-model="loginForm.captchaCode"
            :maxlength="captcha.len"
            placeholder="请输入图片验证码"
            size="large"
          >
            <template #prefix>
              <el-icon class="el-input__icon"><Picture /></el-icon>
            </template>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img
              :src="captcha.src"
              class="login-code-img"
              @click="refreshCaptcha"
              title="点击刷新验证码"
            />
          </div>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item prop="code">
      <el-input
        ref="code"
        v-model="loginForm.code"
        name="code"
        type="text"
        size="large"
        placeholder="输入验证码"
      >
        <template #prefix>
  <el-icon class="el-input__icon"><Bell /></el-icon>
</template>
        <template #append>
  <el-button v-if="!isSendSms" @click.stop="handleSend">获取验证码</el-button>
  <el-button v-else disabled>{{ seconds }} s</el-button>
</template>
      </el-input>
    </el-form-item>
    <el-form-item prop="acceptTerms">
      <el-checkbox v-model="acceptTerms" style="margin-right: 10px" />
      我已阅读并同意
      <a
        style="margin: 0 8px"
        target="_blank"
        href="#/post/1505780345866354690"
      >用户协议</a>
      和
      <a
        style="margin: 0 8px"
        target="_blank"
        href="#/post/1505780504507514881"
      >隐私政策</a>.
    </el-form-item>
    <el-button
      :loading="loading"
      type="primary"
      style="width: 100%; margin-bottom: 30px"
      size="large"
      @click.prevent="handleLogin"
    >登录</el-button>
  </el-form>
  <content-component v-if="showContentVisible" ref="showContent" />
</template>
<script>
import { sendSmsCode } from "@/apis/login";
import { ElMessage } from "element-plus";
import { Bell, Phone, Picture } from "@element-plus/icons-vue";
import { randomLenNum } from "@/utils/util";
import { isvalidatemobile, validatenull } from "@/utils/validate";

export default {
  name: "CodeLoginPage",
  components: { Bell, Phone, Picture },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (isvalidatemobile(value)[0]) {
        callback(new Error(isvalidatemobile(value)[1]));
      } else {
        callback();
      }
    };

    const validateCaptcha = (rule, value, callback) => {
      if (validatenull(value)) {
        callback(new Error("请输入图片验证码"));
      } else {
        callback();
      }
    };

    const validateCode = (rule, value, callback) => {
      if (validatenull(value)) {
        callback(new Error("验证码不能为空"));
      } else if (value.length !== 6) {
        callback(new Error("请输入6位数的验证码"));
      } else {
        callback();
      }
    };

    return {
      activeName: "user",
      loginForm: {
        mobile: undefined,
        captchaCode: undefined, // 图片验证码
        randomStr: undefined, // 验证码标识
        code: undefined, // 短信验证码
      },
      captcha: {
        src: "/code",
        value: "",
        len: 4,
        type: "image",
      },
      codeUrl:
        process.env.NODE_ENV === "production"
          ? "http://pig.hibookapp.com/code"
          : "/code",
      seconds: 60,
      acceptTerms: false,
      isSendSms: false,
      showContentVisible: false,
      timerInterval: undefined,
      loginRules: {
        mobile: [{ required: true, trigger: "blur", validator: validatePhone }],
        captchaCode: [
          { required: true, trigger: "blur", validator: validateCaptcha },
        ],
        code: [{ required: true, trigger: "blur", validator: validateCode }],
      },
      loading: false,
    };
  },
  created() {
    this.refreshCaptcha();
  },
  unmounted() {
    this.stopTimer();
  },
  methods: {
    refreshCaptcha() {
      this.loginForm.captchaCode = "";
      this.loginForm.randomStr = randomLenNum(this.captcha.len, true);
      this.captcha.src = `${this.codeUrl}?randomStr=${
        this.loginForm.randomStr
      }&t=${Date.now()}`;
    },
    showContent(contentId) {
      this.showContentVisible = true;
      this.$nextTick(() => {
        this.$router.push(
          {
            path: "/post",
            query: { contentId: contentId },
          },
          () => {}
        );
      });
    },
    handleSend() {
      if (this.isSendSms) return;

      // 验证手机号
      this.$refs.loginForm.validateField("mobile", (mobileValid) => {
        if (mobileValid) {
          // 验证图片验证码
          this.$refs.loginForm.validateField("captchaCode", (captchaValid) => {
            if (captchaValid) {
              // 调用 API 发送短信
              sendSmsCode(
                this.loginForm.mobile,
                this.loginForm.captchaCode,
                this.loginForm.randomStr
              )
                .then((res) => {
                  if (res.data.data) {
                    this.startTimer();
                    ElMessage.success("验证码发送成功");
                  } else {
                    const errorMsg = res.data.msg || "验证码发送失败";
                    ElMessage.error(errorMsg);

                    // 智能刷新：图片验证码错误时刷新，频率限制时不刷新
                    if (
                      errorMsg.includes("验证码") &&
                      !errorMsg.includes("频繁")
                    ) {
                      this.refreshCaptcha();
                    }
                  }
                })
                .catch((error) => {
                  ElMessage.error(error.message || "验证码发送失败");
                  this.refreshCaptcha();
                });
            }
          });
        }
      });
    },
    handleLogin() {
      var self = this;
      if (!this.acceptTerms) {
        ElMessage({
          message: "You must accept terms and privacy to continue!",
          type: "warning",
        });
        return;
      }
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          self.loading = true;
          self.$store
            .dispatch("LoginByPhone", self.loginForm)
            .then(() => {
              console.log("Login Success!!");
              self.$store.dispatch("GetUserInfo");
              self.$store.dispatch("getMemberInfo");
              self.$store.dispatch("getWritingInfo");
              self.$router.push(
                {
                  path: self.redirect || "/",
                  query: self.otherQuery,
                },
                () => {}
              );
              self.stopTimer();
              self.loading = false;
            })
            .catch(() => {
              self.stopTimer();
              self.loading = false;
            });
        }
      });
    },
    startTimer() {
      var self = this;
      // Get limit in seconds

      this.isSendSms = true;
      // Update the count down every 1 second
      this.timerInterval = setInterval(function () {
        // One second has passed
        self.seconds = self.seconds - 1;

        // If the count down is finished, write some text
        if (self.seconds === 0) {
          self.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timerInterval);
      this.isSendSms = false;
      this.seconds = 60;
    },
  },
};
</script>
<style lang="scss" scoped>
.login-code {
  margin-left: 16px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  height: 100%;
}

.login-code-img {
  width: 100px;
  height: 40px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #dcdfe6;

  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
    border-color: #409eff;
  }
}
</style>
